(function () {
  'use strict';

  var STORAGE_KEY = 'chatelles_wishlist';

  var HEART_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';

  /* ── Storage ────────────────────────────────────────────────────────── */

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isInWishlist(id) {
    return getWishlist().some(function (item) { return String(item.id) === String(id); });
  }

  function toggleItem(id, title, url, image) {
    var list = getWishlist();
    var idx = list.findIndex(function (item) { return String(item.id) === String(id); });
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push({ id: String(id), title: title, url: url, image: image });
    }
    saveWishlist(list);
    return idx === -1; // true = ajouté
  }

  /* ── État des boutons ───────────────────────────────────────────────── */

  function updateBtn(btn, active) {
    btn.classList.toggle('chatelles-wishlist-btn--active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  /* ── Bind un bouton carte ───────────────────────────────────────────── */

  function bindBtn(btn) {
    if (btn.dataset.wishlistBound) return;
    btn.dataset.wishlistBound = '1';
    updateBtn(btn, isInWishlist(btn.dataset.wishlistId));
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var added = toggleItem(
        btn.dataset.wishlistId,
        btn.dataset.wishlistTitle || '',
        btn.dataset.wishlistUrl || window.location.pathname,
        btn.dataset.wishlistImage || ''
      );
      updateBtn(btn, added);
    });
  }

  /* ── Page produit — cœur à droite du H1 ────────────────────────────── */

  function injectProductPageBtn() {
    if (document.querySelector('.chatelles-wishlist-product')) return;

    var picker = document.querySelector('variant-picker[data-product-id]');
    if (!picker) return;

    var productId = picker.dataset.productId;

    var h1 = document.querySelector('.product-information h1')
      || document.querySelector('[data-section-type="product-information"] h1')
      || document.querySelector('main h1');
    if (!h1) return;

    var productUrl = window.location.pathname;
    var imgEl = document.querySelector('.product__media img, .product-media img');
    var productImage = imgEl ? (imgEl.dataset.src || imgEl.src || '') : '';

    var btn = document.createElement('button');
    btn.className = 'chatelles-wishlist-btn chatelles-wishlist-product';
    btn.type = 'button';
    btn.title = (window.chatelles && window.chatelles.i18n && window.chatelles.i18n.wishlistAddTitle) || 'Ajouter aux favoris';
    btn.dataset.wishlistId = productId;
    btn.dataset.wishlistTitle = h1.textContent.trim();
    btn.dataset.wishlistUrl = productUrl;
    btn.dataset.wishlistImage = productImage;
    btn.innerHTML = HEART_SVG;

    var wrapper = document.createElement('div');
    wrapper.className = 'chatelles-product-title-row';
    h1.parentNode.insertBefore(wrapper, h1);
    wrapper.appendChild(h1);
    wrapper.appendChild(btn);

    bindBtn(btn);
  }

  /* ── Init ───────────────────────────────────────────────────────────── */

  function init() {
    document.querySelectorAll('[data-wishlist-id]').forEach(bindBtn);
    injectProductPageBtn();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  // MutationObserver pour les cartes chargées en async (recommandations…)
  var observer = new MutationObserver(function (mutations) {
    var needsInit = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) needsInit = true;
      });
    });
    if (needsInit) init();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  window.chatellesWishlist = { getWishlist: getWishlist };

})();
